"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatBasicBasketDetails = void 0;
var _getters = require("../getters");
var formatBasicBasketDetails = exports.formatBasicBasketDetails = function formatBasicBasketDetails(basket, reservationId) {
  var _basket$bookingFlow$b, _basket$bookingFlow;
  var isBB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var bookingFlowId = (_basket$bookingFlow$b = basket === null || basket === void 0 || (_basket$bookingFlow = basket.bookingFlow) === null || _basket$bookingFlow === void 0 || (_basket$bookingFlow = _basket$bookingFlow.bookingFlowItems) === null || _basket$bookingFlow === void 0 || (_basket$bookingFlow = _basket$bookingFlow.find(bfi => {
    var _basket$selectedRate;
    return (bfi === null || bfi === void 0 ? void 0 : bfi.rateCategory) === (basket === null || basket === void 0 || (_basket$selectedRate = basket.selectedRate) === null || _basket$selectedRate === void 0 ? void 0 : _basket$selectedRate.rateCategory);
  })) === null || _basket$bookingFlow === void 0 ? void 0 : _basket$bookingFlow.bookingId) !== null && _basket$bookingFlow$b !== void 0 ? _basket$bookingFlow$b : '';
  if (isBB) {
    bookingFlowId = 'booking-business';
  }
  var basketToBeSet = {
    hotelId: basket.hotelId,
    startDate: basket.arrival,
    endDate: basket.departure,
    nightsNumber: (0, _getters.getNightsNumber)(basket.arrival, basket.departure),
    rateCode: basket.selectedRate.ratePlanCode,
    adultsNumber: (0, _getters.getMaxValueFromHDPRoomTypes)(basket.selectedRate.roomTypes, 'adults'),
    childrenNumber: (0, _getters.getMaxValueFromHDPRoomTypes)(basket.selectedRate.roomTypes, 'children'),
    reservationId: reservationId,
    bookingFlowId: bookingFlowId
  };
  return basketToBeSet;
};